import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as Success } from '../../../../../resources/images/svg/success.svg';
import { ReactComponent as Fail } from '../../../../../resources/images/svg/fail.svg';
import DefaultButton from '../../../components/buttons/defaultButton/DefaultButton';
import useTranslation from '../../../../hooks/translation/useTranslation';

const statusLogos = {
  success: {
    logo: Success,
    text: 'payment_success',
    buttons: [
      {
        key: '1',
        bgColor: 'green-gr',
        text: 'view_tickets',
        required: 'tickets',
        onClick: 'download',
      },
      {
        key: '2',
        bgColor: 'gray-gr',
        text: 'main_page',
        onClick: 'go_back',
      },
    ],
  },
  fail: {
    logo: Fail,
    text: 'payment_failed',
    buttons: [
      {
        key: '1',
        bgColor: 'primary',
        text: 'main_page',
        onClick: 'go_back',
      },
    ],
  },
};

function TicketPaymentStatus({ payment, handleDownload }) {
  const {
    logo: Status,
    text,
    buttons,
  } = statusLogos[statusLogos?.[payment?.status] ? payment.status : 'fail'];

  const navigate = useNavigate();
  const { trans, currentLanguage } = useTranslation();

  const handleGoBack = () => {
    navigate(`/${currentLanguage || 'ka'}`);
  };

  const buttonClickHandlers = {
    go_back: handleGoBack,
    download: handleDownload,
  };

  return (
    <div className="flex flex-col gap-[58px] items-center">
      <div className="flex flex-col gap-9 items-center">
        <Status />
        <p className="m-0 text-base">{trans(text)}</p>
      </div>
      <div className="flex flex-col gap-5 w-[369px] max-w-full">
        {buttons?.map((button) => (
          <DefaultButton
            key={button.key}
            onClick={buttonClickHandlers[button.onClick]}
            type="button"
            className={`w-full !bg-${button.bgColor}`}
          >
            {trans(button.text)}
          </DefaultButton>
        ))}
      </div>
    </div>
  );
}

export default TicketPaymentStatus;
